export const convertStringToNumber = (value: string): number => Number(value.match(/\d/g)?.join(''));

const getLangFromCurrency = (currency) => {
	switch (currency) {
		case 'DKK':
			return 'da-DK';
		case 'GBP':
			return 'en-UK';
		case 'USD':
			return 'en-US';
		default:
			return;
	}
};

export const convertNumberToCurrency = (value: number, currency: 'DKK' | 'GBP' | 'USD' = 'DKK'): string =>
	new Intl.NumberFormat(getLangFromCurrency(currency), { style: 'currency', currency: currency }).format(value);

export const convertToPercentage = (number: number) => {
	return new Intl.NumberFormat('default', {
		style: 'percent',
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
	}).format(number);
};
